import React from "react";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="app-footer">
            <div className="footer-left">
                Powered by <strong>I-Pro Infinity</strong>
            </div>

            <div className="footer-right">
                Developed by <strong>Deepthi</strong>
            </div>
        </footer>
    );
};

export default Footer;
